import { Button, Theme } from '@mui/material';
import styled from 'styled-components';

import { getThemeValue } from '@/shared/components/ui/button/common/button-common.styled';

import {
  TSelectButtonVariant,
  TStyledSelectButton,
} from './select-button.types';

const VARIANT_STYLES = {
  primary: {
    textColor: 'text.primary',
    textActiveColor: 'primary.main',
    iconColor: 'primary.main',
    arrowColor: 'selectButton.arrowColor.primary',
    typography: 'p8',
    activeTypography: 'p9',
  },
  secondary: {
    textColor: 'text.secondary',
    textActiveColor: 'text.primary',
    iconColor: 'text.secondary',
    arrowColor: 'selectButton.arrowColor.secondary',
    typography: 'button2',
    activeTypography: 'button1',
  },
} as const;

export const StyledSelectedButton = styled(Button)<TStyledSelectButton>`
  && {
    display: flex;
    gap: 0.375rem;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.5rem;
    height: ${({ theme }) => theme.shape.buttonHeight.extraSmall};
    border-radius: ${({ theme }) => theme.shape.buttonRadius.extraSmall};
    text-wrap: nowrap;
    min-width: fit-content;

    color: ${({ theme, $variant = 'secondary', $active }) =>
      getThemeValue(
        theme as Theme,
        VARIANT_STYLES[$variant as TSelectButtonVariant]?.[
          $active ? 'textActiveColor' : 'textColor'
        ],
      )};

    ${({ theme, $variant = 'secondary', $active }) =>
      theme.typography[
        VARIANT_STYLES[$variant as TSelectButtonVariant]?.[
          $active ? 'activeTypography' : 'typography'
        ]
      ]};

    background-color: ${({ theme, $clicked }) =>
      $clicked ? theme.palette.background.clickableHover : 'transparent'};

    &:hover {
      background-color: ${({ theme }) =>
        theme.palette.background.clickableHover};
    }

    svg.select-button-icon,
    svg.select-button-arrow {
      width: 1rem;
      height: 1rem;
    }

    svg.select-button-icon {
      color: ${({ theme, $variant = 'secondary' }) =>
        getThemeValue(
          theme as Theme,
          VARIANT_STYLES[$variant as TSelectButtonVariant]?.iconColor,
        )};
    }

    svg.select-button-arrow {
      color: ${({ theme, $variant = 'secondary' }) =>
        getThemeValue(
          theme as Theme,
          VARIANT_STYLES[$variant as TSelectButtonVariant]?.arrowColor,
        )};
    }

    &:disabled {
      color: ${({ theme }) => theme.palette.text.disabled};
      svg {
        color: ${({ theme }) => theme.palette.text.disabled};
      }
    }
  }
`;
